import { Card } from '@repo/shadcn';
import { useDebounce } from '@uidotdev/usehooks';
import { ReactNode, useState } from 'react';

import {
    AutoCompleteInput,
    Option,
} from '@components/ui/autocomplete/auto-complete-input';

import { useGetSuppliersQuery } from '@/features/slice/suppliers';

type SupplierSelectorCardProps = {
    children?: ReactNode;
    onValueChange: (value: Option) => void;
};

export const SupplierSelectorCard = ({
    children,
    onValueChange,
}: SupplierSelectorCardProps) => {
    const [searchText, setSearchText] = useState('');
    const debouncedSearchText = useDebounce(searchText, 500);
    const { data, isFetching, isLoading } = useGetSuppliersQuery({
        search: debouncedSearchText,
    });

    const suppliers =
        data?.data.map((supplier) => ({
            label: supplier.name,
            value: supplier.id,
        })) ?? [];

    return (
        <Card className="p-4">
            <h2>Select Supplier</h2>
            <AutoCompleteInput
                emptyMessage="No suppliers found"
                isLoading={isLoading || isFetching}
                onInputChange={setSearchText}
                onValueChange={onValueChange}
                options={suppliers}
            />
            {children}
        </Card>
    );
};
